import { Pipe, PipeTransform } from "@angular/core";
import * as UrlParse from "url-parse";

/*
 * Takes a URL and returns only the domain name and
 */
@Pipe({ name: "domainName" })
export class DomainNamePipe implements PipeTransform {
  transform(value: string): string {
    if (value === null || value === "") {
      return value;
    }
    const parsedUrl = new UrlParse(value);
    return parsedUrl.host.replace("www.", "");
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/domain-name.pipe.ts